import React from "react";

const TrackCase: React.FC = () => {
    return (
        <div>Track Cases Content</div>
    );
}

export default TrackCase;